export const env = {
  REACT_APP_EMAILJS_TEMPLATEID: process.env.REACT_APP_EMAILJS_TEMPLATEID,
  REACT_APP_EMAILJS_TEMPLATEID_TWO:
    process.env.REACT_APP_EMAILJS_TEMPLATEID_TWO,
  REACT_APP_EMAILJS_USERID: process.env.REACT_APP_EMAILJS_USERID,
};
